<template>
    <b-container class="admin-dashboard">
        <h1 class="mb-4 text-center">Welcome to admin page</h1>
        <div>
    <b-nav tabs align="center">
        <b-nav-item active :to="'/admin/' + cat.id" v-for="cat in categories" :key="cat.id">{{ cat.name }}</b-nav-item>
    </b-nav>
</div>
    </b-container>
</template>

<script>
import { store } from '../../firebase/categories'

export default {
    name: 'admin-dashboard',
    data(){
        return {
            store
        }
    },
    computed: {
        categories () { 
            return this.store.categories 
        },
    },
}
</script>

<style scoped lang="scss">
@import '../../styles/admin/AdminDashboard.scss'
</style>